// extracted by mini-css-extract-plugin
export default {"header":"ChecklistItemForm_header__gM6Iw","container":"ChecklistItemForm_container__hyjig","iconDelete":"ChecklistItemForm_iconDelete__n1yuJ"};